/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MetaResponse } from '../../models/meta-response';

export interface MetaGet$Json$Params {
}

export function metaGet$Json(http: HttpClient, rootUrl: string, params?: MetaGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<MetaResponse>> {
  const rb = new RequestBuilder(rootUrl, metaGet$Json.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<MetaResponse>;
    })
  );
}

metaGet$Json.PATH = '/api/v1/platform/meta';
